import { SvgIconBase, } from "./Base";


export const Diamond = (props: React.ComponentProps<typeof SvgIconBase>) => {
	return (
		<SvgIconBase {...props} width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" aria-label="Diamond" fill="currentColor">
			<title>Diamond</title>
			<path d="M8 1.5L15 8L8 14.5L1 8L8 1.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
		</SvgIconBase>
	);
};


